import React from 'react';
import client1 from '../../Assets/1677507599579.jpeg'
import client2 from '../../Assets/client2.jpg'
import client3 from '../../Assets/client3.jpg'
import './Testimonials.css'
import '../../App.css'

const Testimonials = () => {

     return (
          <div className='  px-3  md:px-10 lg:px-20  content max-w-[1400px]  mx-auto' >
               <div className='text-center'>
                    <h1
                     data-aos="fade-zoom-in"
                     data-aos-easing="ease-in-back"
                     data-aos-delay="300"
                     data-aos-offset="0"
                    className='text-[80px]  md:px-0  overflow-hidden  md:text-[130px]  font-extrabold  text-gray-500  text-opacity-20'>TESTIMONIAL</h1>
                    <h3 className='text-[35px] md:text-[40px] relative font-semibold text-white -mt-[88px] md:-mt-32'>Client Speak</h3>
                    <div class="flex -mt-2 justify-center">
                         <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
                    </div>
               </div>
               <div className='grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 py-20'>
                    <figure class="snip1157 w-full mx-auto  md:px-0 md:w-11/12 lg:w-12/12">
                         <blockquote
                              data-aos="zoom-in-up"
                              data-aos-delay='100'
                              data-aos-duration='1000'
                              className=' md:bg-opacity-25 font-semibold bg-gray-500  bg-opacity-30 md:bg-gray-600  '>
                              MD.Saroar Jahan has completed a   rigorous amount of JavaScript, HTML, CSS, React and applied these skills to build several projects.We found MD.Saroar Jahan hard working, dedicated and quick learner, who finished the assigned tasks on time. You did it, and we are proud of you!
                              <div class="arrow"></div>
                         </blockquote>
                         <img className='w-20 h-20' src={client1} alt="sq-sample3" />
                         <div class="author">
                              <h5>Jhanker Mahbub <br /> <span>CEO at Programming Hero</span></h5>
                         </div>
                    </figure>
                    <figure class="snip1157 w-full mx-auto mt-10 md:mt-0 md:px-0 md:w-11/12 lg:w-12/12 hover">
                         <blockquote
                              data-aos="zoom-in-up"
                              data-aos-delay='200'
                              data-aos-duration='1000'
                              className=' md:bg-opacity-25 font-semibold bg-gray-500  bg-opacity-30 md:bg-gray-600  '>
                              "MD.Saroar Jahan recently completed an intensive course in website design at Arodesk, showcasing proficiency in JavaScript, HTML and CSS. He applied these skills to successfully build several projects, demonstrating a strong work ethic, dedication, and quick learning abilities.
                              <div class="arrow" ></div>
                         </blockquote>
                         <img className='w-20 h-20' src={client2} alt="sq-sample27" />
                         <div class="author">
                              <h5>Abdullah Al Maruf<span> <br />Web Designer at Arodesk</span></h5>
                         </div>
                    </figure>
                    <figure class="snip1157 w-full mx-auto mt-10 md:mt-10 lg:mt-0  md:px-0 md:w-11/12 lg:w-12/12">
                         <blockquote
                              data-aos="zoom-in-up"
                              data-aos-delay='300'
                              data-aos-duration='1000'
                              className=' md:bg-opacity-25 font-semibold bg-gray-500  bg-opacity-30 md:bg-gray-600  '>
                             Bappy did an awesome job on my website! The design is clean, and it looks super professional. He was quick to understand what I wanted and delivered exactly that.The website design is sleek and professional. Really pleased with the outcome.Working with Bappy was a fantastic experience!
                              <div class="arrow"></div>
                         </blockquote>
                         <img className='w-20 h-20 object-cover' src={client3} alt="sq-sample17" />
                         <div class="author">
                              <h5>Shomik Ujzaman<span> <br /> CEO at Crazy Artist Studio</span></h5>
                         </div>
                    </figure>
               </div>

          </div>
     );
};

export default Testimonials;